export default __webpack_public_path__ + "static/media/cynthia.06f535db.png";